export enum GenerosEnum {
  FEMININO  = 0,
  MASCULINO = 1,
  SEXO_DISTINTO = 2,
  NAO_IDENTIFICADO = 3
}

export interface Generos {
  nome: string;
  valor: GenerosEnum;
}

export const GenerosLista: Generos[] = [
  {nome: 'Feminino', valor: GenerosEnum.FEMININO},
  {nome: 'Masculino', valor: GenerosEnum.MASCULINO},
  {nome: 'Sexo Distinto', valor: GenerosEnum.SEXO_DISTINTO},
  {nome: 'Não identificado', valor: GenerosEnum.NAO_IDENTIFICADO}
];
